<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
//import Basic from "./basic";
import axios from "axios";

import {
  required,
  email,
  //minLength,
  //sameAs,
  maxLength,
  //minValue,
  //maxValue,
  numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Customer Contact",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {  },
  props:{
    idRecord: Number,
    idEntity: [String,null],
    record:   [Object, null]
  },
  data() {
    return {
      info: null,
      componentKey: 0,
      submitted: false,
      title: "Customer contact registration",
      items: [
        {text: "Management",  href: "/"},
        {text: "Customers",   href: "/management/customers"},
        {text: "Location",    active: true}
      ],
      form: {
        id_customer:              "",
        nm_contact:               "",
        de_contactEmail:          "",
        num_contactPhoneNumber:   "",
        num_contactLicenseNumber: "",
        de_position:              "",
      },
    };
  },
  validations: {
    form: {
      id_customer:              { required },
      nm_contact:               { required },
      de_contactEmail:          { required, email },
      num_contactPhoneNumber:   { required, numeric, maxLength: maxLength(10) },
      num_contactLicenseNumber: { required },
      de_position:              { required },
    }
  },
  watch:{
    
  },
  created(){
    if( this.idRecord ){
      this.form.nm_contact                = this.record.nm_contact;
      this.form.de_contactEmail           = this.record.de_contactEmail;
      this.form.num_contactPhoneNumber    = this.record.num_contactPhoneNumber;
      this.form.num_contactLicenseNumber  = this.record.num_contactLicenseNumber;
      this.form.id_customerContact        = this.record.id_customerContact;
      this.form.de_position               = this.record.de_position;
    }
  },
  mounted() {
    
  },
  methods: {
    emit(){
      Swal.close();
      this.$emit('success');
    },


    // eslint-disable-next-line no-unused-vars
    saveCustomerContact(e) {
      let app = this;
      let successMessage = "";

      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if( this.idRecord ){
        this.form.id_customerContact = this.idRecord;
      }

      if( this.idEntity ){
        this.form.id_customer = this.idEntity;
      }

      if( !this.$v.form.$error ){

        Swal.fire({
          title: "Saving customer contact.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/customers.php', {
          request: 'saveCustomerContact',
          data: app.form, 
        })
        .then(function (response) {
          let action = "";

          if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
          if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
          if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }
          
          if( response.data === "OK" ){
            action = "saved";
          }
          if( response.data === "UPDATED" ){
            action = "updated";
          }

          Swal.fire("Good job!", "The customer contact is correctly "+action+"!", "success");
          //app.$router.push({ name: 'industries' });



          if(response.data){
            Swal.fire(
              'Congrats!!!','<p><b>'+successMessage+'</b></p>',
              'success',
            ).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                //app.$router.push({ name: 'industries'});
                app.emit();
              }
            });
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });
      }
    }
  }
};
</script>

<template>



    <form class="needs-validation" @submit.prevent="saveCustomerContact">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="card-title">{{title}}</h4>
                      <p class="card-title-desc">Provide all information related to your customer.</p>

                      <div class="form-group">
                        <label for="nm_contact">Contact name</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.nm_contact.$error }"
                          name="nm_contact"
                          id="nm_contact"
                          v-model="form.nm_contact"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_contact.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_contact.required">Contact name is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_position">Contact job position</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.de_position.$error }"
                          name="de_position"
                          id="de_position"
                          v-model="form.de_position"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_position.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_position.required">Contact job position is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_contactEmail">Email</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.de_contactEmail.$error }"
                          name="de_contactEmail"
                          id="de_contactEmail"
                          v-model="form.de_contactEmail"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_contactEmail.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_contactEmail.required">Contact email is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="num_contactPhoneNumber">Phone number</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.num_contactPhoneNumber.$error }"
                          name="num_contactPhoneNumber"
                          id="num_contactPhoneNumber"
                          v-model="form.num_contactPhoneNumber"
                          value=""
                        >
                        <div v-if="submitted && $v.form.num_contactPhoneNumber.$error" class="invalid-feedback">
                          <span v-if="!$v.form.num_contactPhoneNumber.required">Phone number is required.</span>
                          <span v-if="!$v.form.num_contactPhoneNumber.numeric">Phone number is only numeric digits.</span>
                          <span v-if="!$v.form.num_contactPhoneNumber.maxLength">Phone number maximum length is 10 digits.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="num_contactLicenseNumber">Contact license</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.num_contactLicenseNumber.$error }"
                          name="num_contactLicenseNumber"
                          id="num_contactLicenseNumber"
                          v-model="form.num_contactLicenseNumber"
                          value=""
                        >
                        <div v-if="submitted && $v.form.num_contactLicenseNumber.$error" class="invalid-feedback">
                          <span v-if="!$v.form.num_contactLicenseNumber.required">Contact license is required.</span>
                        </div>
                      </div>

                      

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12 mt-5">
                      <div class="form-group text-center">
                        <button class="btn btn-success mr-3" type="submit">SAVE CONTACT</button>
                        <button class="btn btn-danger" @click="emit();" type="reset">CANCEL </button>
                        <!--
                        <router-link to="/management/products" class="ml-3">
                          <button class="btn btn-danger" type="reset">CANCEL </button>
                        </router-link>
                        -->
                      </div>
                    </div>
                  </div>
                </div>

                
              </div>

              <!--
              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">SAVE PRODUCT</button>
                    <router-link to="/management/products" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
              -->
            </form>

  
</template>
<style type="text/css">
  .form-control-sm{
    display: block;
    width: 100%;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.7875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #505d69;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.2rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
</style>